import React, { useState } from 'react';
import MenuBar from './MenuBar';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet';
import eventData from './AllEventData'; // Import the data

const AllEvent = () => {
  const [activeModal, setActiveModal] = useState(null); // Track which modal to show

  const handleShow = (id) => setActiveModal(id);
  const handleClose = () => setActiveModal(null);

  return (
    <>
      <Helmet>
             <title> Yugalkunj Canada Hamilton </title>
             <meta name="description" content="Join our exciting Summer Camp in Hamilton 2024! Fun-filled activities, learning opportunities, and memorable experiences for kids of all ages." />
             <meta name="keywords" content="Summer camp Hamilton 2024, Summer camp 2024, summer camp, Hamilton, 2024, kids activities, outdoor fun, learning, education" />
             <meta name="author" content="Yugalkunj Canada Hamilton" />
             <link rel="canonical" href="https://yugalkunj.org/Canada/Camps/Summer_Camp_Hamilton" />
           </Helmet>

      <MenuBar />

      <section className="page-banner">
        <div className="image-layer"></div>
        <div className="auto-container">
          <h1>Upcoming Events</h1>
        </div>
        <div className="breadcrumb-box">
          <div className="auto-container">
            <ul className="bread-crumb clearfix">
              <li><Link to='/CAD/Home'>Home</Link></li>
              <li className="active">Upcoming Events</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="causes-section causes-page load-more-section" style={{ paddingTop: "40px" }}>
        <div className="auto-container">
          <div className="row clearfix">
            {eventData.map(event => (
              <div className="cause-block col-lg-4 col-md-6 col-sm-12" key={event.id}>
                <div className="inner-box wow fadeInUp">
                  <div className="image-box">
                    <figure className="image">
                      {event.link ? (
                        <Link to={event.link}>
                          <img src={event.image} className="img-height" alt={event.title} />
                        </Link>
                      ) : (
                        <a href="#">
                          <img src={event.image} className="img-height" alt={event.title} />
                        </a>
                      )}
                    </figure>
                  </div>
                  <div className="lower-content"></div>
                  <div className="link-box">
                    {event.showFlyer ? (
                      <button onClick={() => handleShow(event.id)} className="theme-btn btn-style-two">
                        <span className="btn-title">View Flyer</span>
                      </button>
                    ) : (
                      <Link to={event.link} className="theme-btn btn-style-two">
                        <span className="btn-title">Read More</span>
                      </Link>
                    )}
                  </div>
                </div>

                {/* Modal */}
                {event.showFlyer && (
                  <Modal show={activeModal === event.id} onHide={handleClose} style={{ zIndex: '999999' }}>
                    <Modal.Header closeButton>
                      <Modal.Title>{event.title}</Modal.Title>
                      <Button variant="danger" onClick={handleClose} className="float-end">Close</Button>
                    </Modal.Header>
                    <Modal.Body>
                      <figure className="image">
                        <img src={event.modalImage} alt={event.title} className="img-fluid" />
                      </figure>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>Close</Button>
                    </Modal.Footer>
                  </Modal>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AllEvent;
